import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import { DefinitionsEditModeComponent } from './definitions-edit-mode/definitions-edit-mode.component';
import { DefinitionsReadModeComponent } from './definitions-read-mode/definitions-read-mode.component';
import { PButtonComponent } from '../../../shared/design-system/atoms/p-button/p-button.component';
import { SectionComponent } from '../section/section.component';
import { Report } from '../../models/report.model';

@Component({
  selector: 'app-definitions',
  standalone: true,
  imports: [
    DefinitionsEditModeComponent,
    DefinitionsReadModeComponent,
    PButtonComponent,
    SectionComponent,
  ],
  templateUrl: './definitions.component.html',
  styleUrl: './definitions.component.scss',
})
export class DefinitionsComponent implements OnChanges {
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['definitions']) {
      this.definitionsInternal = structuredClone(this.definitions);
    }
  }

  @Input() definitions!: Report.Definitions;
  @Input() isLoading = false;

  definitionsInternal!: Report.Definitions;

  @Output() definitionsChanged = new EventEmitter<Report.Definitions>();
  @Output() definitionsEnabled = new EventEmitter<boolean>();
  @Output() cancled = new EventEmitter<void>();

  onDefinitionsChanged(definitions: Report.Definitions): void {
    this.definitionsInternal = definitions;
  }

  onSaveSection(): void {
    this.definitionsChanged.emit(this.definitionsInternal);
  }

  onEnabled(isEnabled: boolean): void {
    this.definitionsEnabled.emit(isEnabled);
  }

  onCancled(): void {
    this.cancled.emit();
  }
}
